module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-lace straps-Ki-Lb.a02dc295.png";